/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cityPageSquad.vue?vue&type=template&id=cfeb88d8&scoped=true"
import script from "./cityPageSquad.vue?vue&type=script&lang=js"
export * from "./cityPageSquad.vue?vue&type=script&lang=js"
import style0 from "./cityPageSquad.vue?vue&type=style&index=0&id=cfeb88d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfeb88d8",
  null
  
)

export default component.exports